export default __webpack_public_path__ + "static/media/6.bdfb857e.jpeg";